// extracted by mini-css-extract-plugin
module.exports = {"accordionWrapper":"segment-tracking-form_accordionWrapper__vo7_3"};